export const DASHBOARD_PAGE_NAME = "Dashboard_Auditor";
export const DASHBOARD_TABLE_NAME = "All Audits";